import styled from 'styled-components';
import { colors, fontSize, fontWeight } from '../../theme';

interface QuestionItemProps {
    depth: number;
    isSelected: boolean;
    isVisible: boolean;
    isSelectable: boolean;
}

export const QuestionListContainerStyled = styled.div`
    flex: 1;
    overflow-y: auto;
    padding-right: 4px;
    &::-webkit-scrollbar {
        width: 2px;
        background-color: ${colors.grey500};
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${colors.grey400};
    }
`;

export const QuestionItemStyled = styled.div<QuestionItemProps>`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    padding-left: ${({ depth }: QuestionItemProps) => 8 + depth * 16}px;
    border-radius: 6px;
    cursor: ${({ isSelectable }: QuestionItemProps) => (isSelectable ? 'pointer' : 'default')};
    margin-bottom: 2px;
    opacity: 1;
    background-color: ${({ isSelected }: QuestionItemProps) => (isSelected ? colors.lighten : 'transparent')};
    border: 1px solid ${({ isSelected }: QuestionItemProps) => (isSelected ? colors.default : 'transparent')};
    transition: background-color 0.1s ease, border-color 0.1s ease;
    user-select: none;

    &:hover {
        background-color: ${({ isSelected, isSelectable }: QuestionItemProps) => {
        if (isSelected) { return colors.lighten; }
        if (isSelectable) { return colors.grey700; }

        return 'transparent';
    }};
    }
`;

interface TypeBadgeProps {
    typeColor: string;
}

export const QuestionTypeBadgeStyled = styled.span<TypeBadgeProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 4px;
    background-color: ${({ typeColor }: TypeBadgeProps) => typeColor};
    color: white;
    font-size: 10px;
    font-weight: 600;
    flex-shrink: 0;
`;

export const CollapseToggleStyled = styled.button`
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    color: ${colors.grey400};
    border-radius: 3px;

    &:hover {
        color: ${colors.grey200};
        background-color: ${colors.grey500};
    }
`;

export const CollapseSpacerStyled = styled.div`
    width: 16px;
    height: 16px;
    flex-shrink: 0;
`;

export const QuestionListHeaderStyled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid ${colors.grey500};
`;

export const QuestionToolbarStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 8px;
`;

export const TypeFilterRowStyled = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
`;

interface TypeFilterChipProps {
    active: boolean;
    chipColor: string;
}

export const TypeFilterChipStyled = styled.button<TypeFilterChipProps>`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 12px;
    border: 1px solid ${({ active, chipColor }: TypeFilterChipProps) => (active ? chipColor : colors.grey500)};
    background-color: ${({ active, chipColor }: TypeFilterChipProps) => (active ? chipColor : 'transparent')};
    color: ${({ active }: TypeFilterChipProps) => (active ? 'white' : colors.grey300)};
    font-size: ${fontSize.s};
    font-weight: ${fontWeight.regular};
    cursor: pointer;
    transition: all 0.1s ease;
    font-family: Barlow, sans-serif;

    &:hover {
        border-color: ${({ chipColor }: TypeFilterChipProps) => chipColor};
        color: ${({ active }: TypeFilterChipProps) => (active ? 'white' : colors.grey200)};
    }
`;

export const SelectionActionsRowStyled = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;

export const SelectActionButtonStyled = styled.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-family: Barlow, sans-serif;
    font-size: ${fontSize.s};
    font-weight: ${fontWeight.regular};
    color: ${colors.default};
    text-decoration: underline;

    &:hover {
        color: ${colors.defaultHover};
    }

    &:disabled {
        color: ${colors.grey400};
        text-decoration: none;
        cursor: default;
    }
`;

export const SelectionSeparatorStyled = styled.span`
    color: ${colors.grey500};
    font-size: ${fontSize.s};
`;
